document.addEventListener('DOMContentLoaded', function() {
    // Edit this URL to point to your Sticky.io checkout
    const baseUrl = 'secure.natureleaforganics.com';
    document.body.addEventListener('click', function(e) {
        const checkoutButton = e.target.closest('#DM_CartDrawer-Checkout, #CartDrawer-Checkout, #checkout, .cart__checkout, #kaching-cart__checkout-button, .kaching-cart__checkout-button, [data-kaching-checkout]');
        if (!checkoutButton) return;
        e.preventDefault();
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                if (cart.items.length === 0) return;
                const productsParam = cart.items.map(item => {
                    return `${item.product_id}:${item.variant_id}:${item.quantity}`;
                }).join(';');
                const currency = cart.currency;
                const country = (cart.attributes && cart.attributes.country) ? cart.attributes.country : '';
                const token = cart.token ? cart.token.split('?key=')[0] : '';
                // Check cart-level discount codes first, then fall back to line-level discount titles
                let discountCode = '';
                if (cart.discount_codes && cart.discount_codes.length > 0) {
                    discountCode = cart.discount_codes[0].code;
                } else {
                    const firstItemWithDiscount = cart.items.find(item => item.discounts && item.discounts.length > 0);
                    if (firstItemWithDiscount) {
                        discountCode = firstItemWithDiscount.discounts[0].title;
                    }
                }
                let url = `https://${baseUrl}?products=${productsParam}&cur=${currency}`;
                if (country) url += `&country=${country}`;
                console.log(discountCode);
                if (discountCode) url += `&cpn=${encodeURIComponent(discountCode)}`;
                if (token) url += `&token=${encodeURIComponent(token)}`;
                window.location.href = url;
            });
    });
});